module.exports = __webpack_public_path__ + "img/待付款.7c719f8a.svg";